export default {
  isModalVisible: false,
  user: {
    name: '',
    email: ''
  },
  excludeFromBaseServices: [
    'internet.components.mbps_250.components.wifi360',
    'internet.components.mbps_120.components.wifi360',
    'tv.components.chan_90.components.app_nowo',
    'tv.components.chan_90_plus.components.app_nowo',
    'tv.components.chan_33.components.app_nowo',
    'tv.components.chan_82.components.app_nowo'
  ]
};



// WEBPACK FOOTER //
// ./src/store/modules/fis/state.js